module.exports = __webpack_public_path__ + "static/media/favoriti_si.321b7c47.png";